import cn from 'classnames';

import ProposalContact from 'components/proposal-page/ProposalContact';

import { IProposalData_Items, ITibiProposalData } from 'source/NFR.types';

const TibiProposalDataItem: React.FC<IProposalData_Items> = item => (
  <>
    <span className="tibi-proposal-data--label">{item.label}</span>
    <span className="tibi-proposal-data--value">
      {item.text && <span className="tibi-proposal-data--value-text">{item.text}</span>}
      {item.links?.map(link => (
        <a className="tibi-proposal-data--link" href={link.url} key={link.text}>
          <span>{link.text}</span>
        </a>
      ))}
    </span>
  </>
);

TibiProposalDataItem.displayName = 'TibiProposalData.Item';

const TibiProposalData: React.FC<ITibiProposalData> & {
  Item: React.FC<IProposalData_Items>;
  // Main component with internal TibiProposalDataItem helper
  // eslint-disable-next-line react/no-multi-comp
} = ({ items = [], contacts, contactLabel, rightColumn = false, arbitrary = false }) => {
  if (rightColumn && !arbitrary) {
    return (
      <>
        {items?.map((item, idx) => (
          <div style={{ gridRowStart: idx + 1 }} className="tibi-proposal-data--right" key={item.label}>
            <TibiProposalDataItem {...item} />
          </div>
        ))}
        {contacts && (
          <div style={{ gridRowStart: items.length + 1 }} className="tibi-proposal-data--right">
            <span className="tibi-proposal-data--label">{contactLabel}</span>
            <div
              className={cn('tibi-proposal-data--value', {
                'tibi-proposal-data--value-multiple-contacts': contacts.length > 1
              })}
            >
              {contacts?.map((contact, i) => (
                <ProposalContact key={i} {...contact} />
              ))}
            </div>
          </div>
        )}
      </>
    );
  } else if (!rightColumn && !arbitrary) {
    return items?.map(item => (
      <div className="tibi-proposal-data--left" key={item.label}>
        <TibiProposalDataItem {...item} />
      </div>
    ));
  }

  if (arbitrary) {
    return items?.map((item, idx) => (
      <div className={`tibi-proposal-data${idx % 2 === 0 ? '--left' : '--right'}`} key={item.label}>
        <TibiProposalDataItem {...item} />
      </div>
    ));
  }

  return null;
};

TibiProposalData.Item = TibiProposalDataItem;

export default TibiProposalData;
